(function() {
    'use strict';

    angular
        .module('app')
        .controller('courseListSelectorController', courseListSelectorController);

    function courseListSelectorController($q, $rootScope, $scope, $uibModalInstance, trainingInnerService, courseItem) {
        var vm = this;
        vm.cancel = cancel;
        vm.itemSelected = itemSelected;

        onInit();

        function onInit() {
            //console.log('courseItem:', courseItem);
            vm.courseList = courseItem.courseList;
            console.log('vm.courseList:', vm.courseList);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function itemSelected(list, item) {
            var result = [];

            // courseItem.selectedItemName = item.showName;

            result.push(list);
            result.push(item);
            $uibModalInstance.close(result);
        }
    }
})();